export default {
    女装: "女装",
    男装: "男装",
    手机和小工具: "手机和小工具",
    居家生活: "居家生活",
    电脑及周边设备: "电脑及周边设备",
    美容及个人护理: "美容及个人护理",
    家用电器: "家用电器",
    健康与保健: "健康与保健",
    食品和饮料: "食品和饮料",
    玩具_儿童和婴儿: "玩具、儿童和婴儿",
    童装时尚: "童装时尚",
    视频游戏: "视频游戏",
    运动与户外: "运动与户外",
    爱好与书籍: "爱好与书籍",
    相机和无人机: "相机和无人机",
    宠物食品及用品: "宠物食品及用品",
    女士包袋: "女士包袋",
    男士包袋: "男士包袋",
    珠宝及配饰: "珠宝及配饰",
    手表: "手表",
    女鞋: "女鞋",
    男装鞋: "男装鞋",
    汽车: "汽车",
    我附近的ShopeePay: "我附近的 ShopeePay",
    餐饮_旅行和服务: "餐饮、旅行和服务",
    旅行及行李: "旅行及行李",
    各种各样的: "各种各样的",
    我是来买什么的: "我是来买什么的",
    对不起_找不到_相关的商品: "对不起，找不到[{0}]相关的商品",
    类别: "类别",
    产品: "产品",
    店铺: "店铺",
    首页: "首页",
    限时秒杀: "限时秒杀",
    博客: "博客",
    所有品牌: "所有品牌",
    所有类别: "所有类别",
    我的购物车: "我的购物车",
    发货信息: "发货信息",
    交货信息: "交货信息",
    付款: "付款",
    确认: "确认",
    您的购物车是空的: "您的购物车是空的",
    价格: "价格",
    税: "税",
    数量: "数量",
    总计: "总计",
    移除: "移除",
    返回商店: "返回商店",
    继续发货: "继续发货",
    筛选: "筛选",
    价格范围: "价格范围",
    排序方式: "排序方式",
    最新: "最新",
    最旧: "最旧",
    价格从低到高: "价格从低到高",
    价格从高到低: "价格从高到低",
    选择交货类型: "选择交货类型",
    送货上门: "送货上门",
    继续付款: "继续付款",
    任何其他信息: "任何其他信息",
    或者: "或者",
    您的钱包余额: "您的钱包余额",
    余额不足: "余额不足",
    支付: "支付",
    我同意: "我同意",
    条款和条件: "条款和条件",
    退货政策: "退货政策",
    隐私政策: "隐私政策",
    概括: "概括",
    项目: "项目",
    全部的: "全部的",
    小计: "小计",
    总运费: "总运费",
    有优惠码吗_在这里输入: "有优惠码吗？在这里输入",
    申请: "申请",
    编辑: "编辑",
    删除: "删除",
    添加新地址: "添加新地址",
    继续交货信息: "继续交货信息",
    选择一个地址: "选择一个地址",
    购买历史: "购买历史",
    下载: "下载",
    已发送退款请求: "已发送退款请求",
    对比: "对比",
    对话: "对话",
    我的钱包: "我的钱包",
    工单: "工单",
    管理个人资料: "管理个人资料",
    登出: "登出",
    重置对比列表: "重置对比列表",
    您的对比列表为空: "您的对比列表为空",
    在您的购物车中: "在您的购物车中",
    在您的愿望清单中: "在您的愿望清单中",
    在您的预定列表中: "在您的预定列表中",
    下载您的产品: "下载您的产品",
    选项: "选项",
    什么都没找到: "什么都没找到",
    特色产品: "特色产品",
    最畅销: "最畅销",
    前_名: "前{0}名",
    查看更多: "查看更多",
    查看所有类别: "查看所有类别",
    十大品牌: "十大品牌",
    查看所有品牌: "查看所有品牌",
    登录: "登录",
    手机号码: "手机号码",
    密码: "密码",
    密码长度为6到16个字符: "密码长度为6到16个字符",
    验证码: "验证码",
    登录中: "登录中",
    游客登录: "游客登录",
    注册您的商店: "注册您的商店",
    现在申请: "现在申请",
    成为商家: "成为商家",
    现在注册: "现在注册",
    登录成功: "登录成功",
    通知: "通知",
    未找到通知: "未找到通知",
    评论: "评论",
    估计运输时间: "估计运输时间",
    天: "天",
    所售: "所售",
    给商家留言: "给商家留言",
    规格: "规格",
    库存: "库存",
    总价: "总价",
    添加到购物车: "添加到购物车",
    立即购买: "立即购买",
    缺货: "缺货",
    添加到愿望清单: "添加到愿望清单",
    加入对比列表: "加入对比列表",
    退款: "退款",
    查看条款: "查看条款",
    分享: "分享",
    描述: "描述",
    相关产品: "相关产品",
    没有人问过商家: "没有人问过商家",
    该产品暂无评论: "该产品暂无评论",
    客户评论: "客户评论",
    访问商店: "访问商店",
    畅销产品: "畅销产品",
    日期: "日期",
    订单编号: "订单编号",
    总额: "总额",
    状态: "状态",
    愿望清单: "愿望清单",
    还没有添加任何东西: "还没有添加任何东西",
    注册: "注册",
    邀请码: "邀请码",
    请输入邀请码: "请输入邀请码",
    用户名: "用户名",
    请输入用户名: "请输入用户名",
    用户名长度为6_14个字符: "用户名长度为6-14个字符",
    昵称: "昵称",
    请输入手机号码: "请输入手机号码",
    手机号码格式错误: "手机号码格式错误",
    密码长度为6_16个字符: "密码长度为6-16个字符",
    确认密码: "确认密码",
    请输入确认密码: "请输入确认密码",
    提款密码: "提款密码",
    请输入提款密码: "请输入提款密码",
    提款密码长度为4_16个字符: "提款密码长度为4-16个字符",
    请输入验证码: "请输入验证码",
    在_s后发送: "在{0}s后发送",
    发送验证码: "发送验证码",
    注册即表示您同意我们的条款和条件: "注册即表示您同意我们的条款和条件。",
    创建账号: "创建账号",
    验证码发送成功: "验证码发送成功",
    确认密码不一致: "确认密码不一致",
    提款密码必须为数字: "提款密码必须为数字",
    注册成功: "注册成功",
    购物车: "购物车",
    账户: "账户",
    我的账户: "我的账户",
    已经有一个账户: "已经有一个账户",
    新地址: "新地址",
    编辑地址: "编辑地址",
    保存: "保存",
    是否默认: "是否默认",
    具体地址: "具体地址",
    请输入具体地址: "请输入具体地址",
    地区: "地区",
    请输入地区: "请输入地区",
    城市: "城市",
    请输入城市: "请输入城市",
    省份: "省份",
    请输入省份: "请输入省份",
    邮政编码: "邮政编码",
    请输入邮政编码: "请输入邮政编码",
    电话号码: "电话号码",
    请输入电话号码: "请输入电话号码",
    收货人: "收货人",
    请输入收货人: "请输入收货人",
    保存成功: "保存成功",
    最畅销的商家: "最畅销的商家",
    查看所有的商家: "查看所有的商家",
    支持政策: "支持政策",
    您的电子邮件地址: "您的电子邮件地址",
    订阅: "订阅",
    联系方式: "联系方式",
    地址: "地址",
    美国伊利诺伊州霍夫曼庄园: "美国伊利诺伊州霍夫曼庄园",
    快速链接: "快速链接",
    商家政策: "商家政策",
    submit: "提交",
    提款银行卡: "提款银行卡",
    我的面板: "我的面板",
    提示: "提示",
    确定登出吗: "确定登出吗",
    确定: "确定",
    取消: "取消",
    项目添加到您的购物车: "项目添加到您的购物车",
    经常一起购买: "经常一起购买",
    返回购物: "返回购物",
    进行结算: "进行结算",
    帮助热线: "帮助热线",
    查看所有通知: "查看所有通知",
    请输入密码: "请输入密码",
    前往充值: "前往充值",
    购物车物品: "购物车物品",
    查看购物车: "查看购物车",
    钱包余额: "钱包余额",
    充值钱包: "充值钱包",
    钱包充值_线下_: "钱包充值(线下)",
    申请提款: "申请提款",
    钱包收支明细: "钱包收支明细",
    批准: "批准",
    提现历史记录: "提现历史记录",
    类型: "类型",
    信息: "信息",
    付款方式: "付款方式",
    请选择付款方式: "请选择付款方式",
    Bill_Type_RECHARGE_BACK: "后台充值",
    Bill_Type_RECHARGE_ONLINE: "在线充值",
    Bill_Type_RECHARGE_REGISTER: "注册赠送",
    Bill_Type_RECHARGE_JACKPOT: "充值彩金",
    Bill_Type_RECHARGE_PRESENT: "充值奖励",
    Bill_Type_RECHARGE_FROM_COMMISSION: "佣金转入",
    Bill_Type_RECHARGE_TG_COMMISSION: "充值推广佣金",
    Bill_Type_REGISTER_TG_COMMISSION: "注册推广佣金",
    Bill_Type_WITHDRAW: "提现",
    Bill_Type_WITHDRAW_REJECT: "提现驳回",
    Bill_Type_DEDUCT_HANDLE: "手动扣款",
    Bill_Type_DEDUCT_RECHARGE_MONEY: "充值校正",
    Bill_Type_MINING_PROFIT: "挖矿收益",
    Bill_Type_MINING_PROFIT_COMMISSION: "挖矿收益推广佣金",
    Bill_Type_VIP_UPGRADE: "升级VIP",
    Bill_Type_FINANCE_BUY: "理财产品购买",
    Bill_Type_FINANCE_CAPITAL_RETURN: "理财余额退回",
    Bill_Type_FINANCE_FEE: "理财手续费",
    Bill_Type_FINANCE_PROFIT: "理财收益",
    Bill_Type_FINANCE_BUY_COMMISSION: "理财产品购买佣金",
    Bill_Type_FINANCE_PROFIT_COMMISSION: "理财产品收益佣金",
    Bill_Type_WHEEL_DRAW: "大转盘抽奖",
    Bill_Type_BUY: "购买商品",
    Bill_Type_PAY_SHOP: "支付发货费用",
    Bill_Type_BUY_COMMISSION: "购买商品佣金",
    Bill_Type_DEPOSIT: "缴纳保证金",
    Bill_Type_STORE_BUY: "购买商品",
    Bill_Type_STORE_BUY_REFUND: "购买商品退款",
    Bill_Type: "账变类型",
    Before_Money: "之前金额",
    Deal_Money: "账变金额",
    After_Money: "之后金额",
    Bill_Time: "账变时间",
    No_More_Data: "没有更多数据",
    Apply_Money: "申请金额",
    Apply_Time: "申请时间",
    Withdraw_Info: "手续费：{fee}，到账：{money}",
    提款订单状态_CHECKING: "待审核",
    提款订单状态_TRANSFERRING: "转账中",
    提款订单状态_PASS: "已确认",
    提款订单状态_REJECT: "已驳回",
    暂无可用充值方式: "暂无可用充值方式",
    钱包收款码: "钱包收款码",
    钱包地址: "钱包地址",
    金额限制: "金额限制",
    复制: "复制",
    付款凭证: "付款凭证",
    收款银行: "收款银行",
    收款人: "收款人",
    收款账号: "收款账号",
    付款银行: "付款银行",
    付款人: "付款人",
    付款账号: "付款账号",
    请输入付款银行: "请输入付款银行",
    请输入付款人: "请输入付款人",
    请输入付款账号: "请输入付款账号",
    请上传付款凭证: "请上传付款凭证",
    充值金额: "充值金额",
    请输入充值金额: "请输入充值金额",
    submitting: "提交中...",
    Confirm: "提交",
    Commit_Success: "提交成功",
    balanceType_BALANCE: "余额",
    balanceType_COMMISSION: "佣金",
    Balance: "账户余额",
    Wash_Money: "打码",
    请选择银行账户: "请选择银行账户",
    卡号类型: "卡号类型",
    提现金额: "提现金额",
    提款金额: "提款金额",
    不能为空: "不能为空",
    金额不正确: "金额不正确",
    please_input_withdraw_password: "请输入提款密码",
    withdraw_password_format_error: "提款密码必须是4-16位字符",
    Fee: "手续费",
    实际到账: "实际到账",
    交易币种: "交易币种",
    原始密码: "原始密码",
    confirm_password_error: "两次输入的密码不正确",
    save_success: "保存成功",
    please_input: "请输入",
    old_password: "旧密码",
    new_password: "新密码",
    please_input_confirm_password: "请再次确认密码",
    没有找到符合条件的商品: "没有找到符合条件的商品",
    Search: "搜索",
    全部: "全部",
    EnumGoodsOrderState_USER_PAY: "待配送",
    EnumGoodsOrderState_SHOP_PAY: "配送中",
    EnumGoodsOrderState_SUCCESS: "完成",
    EnumGoodsOrderState_CANCEL: "已取消",
    EnumGoodsOrderState_REFUND_SUCCESS: "已退款",
    订单号: "订单号",
    用户名称: "用户名称",
    收益: "收益",
    支付时间: "支付时间",
    配送时间: "配送时间",
    完成时间: "完成时间",
    发货: "发货",
    全选: "全选",
    物品已添加到愿望清单: "物品已添加到愿望清单",
    物品已添加到比较列表: "物品已添加到比较列表",
    购买成功提示: "恭喜您，购买成功",
    订单列表: "订单列表",
    商品名: "商品名",
    图片: "图片",
    没有品牌: "没有品牌",
    基本信息: "基本信息",
    Account_Name: "开户姓名",
    Bank_Account: "银行账户",
    Bank_Phone: "预留手机号",
    IFSC: "IFSC账号",
    UPI: "UPI账号",
    PIX: "PIX账号",
    CPF: "CPF账号",
    GCASH: "GCASH账号",
    POWWI: "POWWI账号",
    身份证号: "身份证号",
    Edit: "修改",
    Delete: "删除",
    Add: "新增",
    Forget_Withdraw_Password: "忘记提款密码",
    Bank_Card_Info: "银行卡信息",
    收款人地址: "收款人地址",
    SWIFT: "SWIFT",
    Bank_Branch: "支行名称",
    分行代码: "分行代码",
    银行地址: "银行地址",
    Email: "Email",
    银行卡长度必须超过: "银行卡长度必须超过{length}",
    银行卡格式不正确: "银行卡格式不正确",
    Do_you_confirm_delete: "是否确认删除？",
    Please_Login_First: "请先登录",
    Bank_Name: "银行名称",
    Please_add_bank_first: "您尚未绑定银行卡，请先添加",
    withdrawType: "提款类型",
    withdraw_money_limit: "提款金额必须大于0且小于或等于{balance}",
    withdraw_times_limit: "您今日提取了{todayWithdrawNum}次，在{limitTimes}次之后将收取{withdrawFee}％的手续费。 是否确定提款？",
    Copy_Success: "复制成功",
    商店首页: "商店首页",
    所有产品: "所有产品",
    新到货产品: "新到货产品",
    所有商家: "所有商家",
    请上传: "请上传",
    请输入: "请输入",
    忘记密码: "忘记密码",
    记得我: "记得我",
    共_件: "共{0}件",
    取消订单: "取消订单",
    申请退款: "申请退款",
    未知商家: "未知商家",
    到账: "到账",
    提款订单状态: "提款订单状态",
    前_名类别: "前{0}名类别",
    取消订单原因_不想要了: "不想要了",
    取消订单原因_商品错选_多选: "商品错选/多选",
    取消订单原因_商品无货: "商品无货",
    取消订单原因_地址信息填写错误: "地址信息填写错误",
    取消订单原因_商品降价: "商品降价",
    取消订单原因_价格高于其他平台: "价格高于其他平台",
    取消订单原因_没用_少用_错用优惠: "没用/少用/错用优惠",
    退款原因_拍错_多拍_不喜欢: "拍错/多拍/不喜欢",
    退款原因_商品成分描述不符: "商品成分描述不符",
    退款原因_与商家协商一致退款: "与商家协商一致退款",
    退款原因_生产日期_保质期与商品描述不符: "生产日期/保质期与商品描述不符",
    退款原因_图片_产地_批号_规格等描述不符: "图片/产地/批号/规格等描述不符",
    退款原因_质量问题: "质量问题",
    退款原因_商品变质_发霉_有异物: "商品变质/发霉/有异物",
    退款原因_少件_含缺少配件_: "少件（含缺少配件）",
    退款原因_收到商品时有破损_污渍_变形: "收到商品时有破损/污渍/变形",
    退款原因_假冒品牌: "假冒品牌",
    退款原因_发票问题: "发票问题",
    退款原因_商家发错货: "商家发错货",
    退款原因_预约不到_商家不给退换: "预约不到/商家不给退换",
    退款失败: "退款失败",
    退款处理中: "退款处理中",
    默认: "默认",
    产品查询: "产品查询",
    商店LOGO: "商店LOGO",
    推广码: "推广码",
    查看所有: "查看所有",
    确认收货成功: "确认收货成功",
    物流公司: "物流公司",
    物流单号: "物流单号",
    发货时间: "发货时间",
    请先选择商品规格: "请先选择商品规格",
    个人信息: "个人信息",
    您的用户名: "您的用户名",
    你的名字: "你的名字",
    登录名: "用户名",
    你的邮件: "你的邮件",
    你的密码: "你的密码",
    重复输入密码: "重复输入密码",
    店铺名称: "店铺名称",
    证书类型: "证书类型",
    身份证: "身份证",
    护照: "护照",
    驾驶执照: "驾驶执照",
    社会保障卡: "社会保障卡",
    证书正面: "证书正面",
    证书反面: "证书反面",
    确认收货: "确认收货",
    请选择取消订单的原因必选: "请选择取消订单的原因（必选）:",
    请选择申请退款的原因必选: "请选择申请退款的原因（必选）:",
    留言: "留言",
    请输入留言: "请输入留言",
    没有帐户: "没有帐户",
    钱包充值: "钱包充值",
    输入您的文字: "输入您的文字",
    商家登录: "商家登录",
    有关此产品的任何查询: "有关此产品的任何查询",
    产品名称: "产品名称",
    你的问题: "你的问题",
    白银店铺: "白银店铺",
    铂金店铺: "铂金店铺",
    钻石店铺: "钻石店铺",
    照片: "照片",
    已退货: "已退货",
    邮寄状态: "邮寄状态",
    订单摘要: "订单摘要",
    收件地址: "收件地址",
    订购日期: "订购日期",
    订单状态: "订单状态",
    总订单金额: "总订单金额",
    邮寄方式: "邮寄方式",
    附加信息: "附加信息",
    订单详细信息: "订单详细信息",
    交货类型: "交货类型",
    进行评论: "进行评论",
    已评论: "已评论",
    订单金额: "订单金额",
    优惠券: "优惠券",
    统一运费: "统一运费",
    送货地址: "送货地址",
    评分: "评分",
    你的意见: "你的意见",
    匿名: "匿名",
    现金: "现金",
    详情: "详情",
    收货地址: "收货地址",
    暂时没有对话: "暂时没有对话",
    你: "你",
    输入您的回复: "输入您的回复",
    删除成功: "删除成功",
    品牌: "品牌",
    已缴纳的保证金: "已缴纳的保证金",
    黄金店铺: "黄金店铺",
    没有更多数据: "没有更多数据",
    站内信: "站内信",
    系统通知: "系统通知",
    邮箱: "邮箱",
    手机号: "手机号",
    你的手机号: "你的手机号",
    营业执照: "营业执照",
    你的邮箱: "你的邮箱",
    搜索结果: "搜索结果",
    系统公告: "系统公告",
    客服: "客服",
    消息已撤回: '消息已撤回',
    物流详情: '物流详情',
    充值: '充值',
    提现: '提现',
    信用分: '信用分',
    余额: '余额',
    佣金: '佣金',
    继续购物: '继续购物',
    订单结算: '订单结算',
    加入对比: '加入对比',
    佣金余额: "佣金余额",
    佣金转余额: "佣金转余额",
    转入金额: "转入金额",
    不填则全部转入: "不填则全部转入",
    全部转入: "全部转入",
    转入成功: "转入成功",
    转入金额格式错误: "转入金额格式错误",
    刷新: "刷新",
    刷新成功: "刷新成功",
    官网: "官网",
    税号: '税号',
    订单: '订单',
    合计: "合计",
    系统安全: "系统安全",
    Recharge_Money_Limit: '充值金额必须在{min}和{max}之间',
    限时优惠: '限时优惠',
    高价回收: '高价回收',
    姓名: '姓名',
    商品订单号: '商品订单号',
    商品在线回收: '商品在线回收',
    提交: '提交',
    回收记录: '回收记录',
    回收状态: '回收状态',
    回收价格: '回收价格',
    纳税码: '纳税码',
    买家登录: '登录',
    买家注册: '注册',
    助力提示: '为商户助力可提升平台对其店铺的曝光度，累计助力天数越高曝光量越高。',
    已累计助力: '已累计助力',
    今日已助力: '今日已助力',
    立即助力: '立即助力',
    商家助力: '商家助力',
    证件号码: '证件号码',
    证书号码: '证书号码',
    男鞋: '男鞋',
    游戏玩具: '游戏玩具',
    使用条款: '使用条款',
    商家: '商家',
    已助力: '已助力',
    被助力: '被助力',
    用户: '用户',
    助力记录: '助力记录',
    消息类型: '消息类型',
    消息内容: '消息内容',
    链接: '链接',
    文本: '文本',
    清空: '清空',
    评论成功: '评论成功',
    扫描二维码: '扫描二维码',
    转入: '转入',
    收款: '收款',
    任务下单中心: '任务下单中心',
    记录: '记录',
    任务倒计时: '任务倒计时',
    倒计时后自动放弃: '倒计时后自动放弃',
    业务码: '业务码',
    选择商品分类: '选择商品分类',
    可多选: '可多选',
    加载分类中: '加载分类中',
    暂无分类: '暂无分类',
    产品类别: '产品类别',
    账户余额: '账户余额',
    立即结算: '立即结算',
    任务已自动放弃: '任务已自动放弃',
    商品分类: '商品分类',
    订单详情: '订单详情',
    预计收益: '预计收益',
    预计佣金收益: '预计佣金收益',
    收益率: '收益率',
    扣款账户: '扣款账户',
    确认结算: '确认结算',
    未选择: '未选择',
    请选择商品分类: '请选择商品分类',
    下单成功: '下单成功',
    下单失败: '下单失败',
    请重试: '请重试',
    订单记录: '订单记录',
    没有更多了: '没有更多了',
    业务号: '业务号',
    商品类型: '商品类型',
    佣金收益: '佣金收益',
    待结算: '待结算',
    已结算: '已结算',
    已取消: '已取消',
    加载失败: '加载失败',
    倒计时: '倒计时',
    随机商品: '随机商品',
    为: '为',
    商户助力可提升商品曝光度: '商户助力可提升商品曝光度',
    累计助力越高推荐权重越高: '累计助力越高推荐权重越高',
    实时助力动态: '实时助力动态',
    助力奖励: '助力奖励',
    随机奖励金额已生成: '随机奖励金额已生成',
    开心收下: '开心收下',
    助力已结束: '助力已结束',
    助力成功: '助力成功',
    成功: '成功',
    进行中: '进行中',
    等待: '等待',
    助力失败: '助力失败',
    任务: '任务',
    下单失败_请稍后重试: '下单失败，请稍后重试',
    language: "中文"
};
;
